// @i18n-ignore-file
export const TEMPLATES = {
  HOME: 'HOME',
  COLLECTION: 'COLLECTION',
  LANDING: 'LANDING',
  PARTNER_PDP: 'PARTNER_PDP',
  PDP: 'PDP',
  UNKNOWN: 'UNKNOWN',
  OLD_SITE: 'OLD_SITE',
  SEARCH_PAGE: 'SEARCH_PAGE',
} as const

export type TemplateType = (typeof TEMPLATES)[keyof typeof TEMPLATES]

export const MODULES = {
  UNKNOWN: 'UNKNOWN',
  CREATE_REVIEW: 'CREATE_REVIEW',
  COLLECTION_FILTER: 'COLLECTION_FILTER',
  BEST_SELLER_COLLECTION_FILTER: 'BEST_SELLER_COLLECTION_FILTER',
  COLLECTION_PRODUCT_LOAD: 'COLLECTION_PRODUCT_LOAD',
  APP_CONTEXT: 'APP_CONTEXT',
  RETURNS: 'RETURNS',
  RETURN_CONTROLLER: 'RETURN_CONTROLLER',
  CART: 'CART',
  ID_ME: 'ID_ME',
  PRODUCT_LIST_THREE: 'PRODUCT_LIST_THREE',
  PRODUCT_LIST_TWO: 'PRODUCT_LIST_TWO',
  ALGOLIA: 'ALGOLIA',
  SEARCH: 'SEARCH',
  WISHLIST: 'WISHLIST',
  TRACKING: 'TRACKING',
  CUSTOMER: 'CUSTOMER',
  REVIEW: 'REVIEW',
  PRODUCT: 'PRODUCT',
  PRODUCT_SERVICE: 'PRODUCT_SERVICE',
  CHECKOUT: 'CHECKOUT',
  EVENT_TRACKING: 'EVENT_TRACKING',
  ATTENTIVE: 'ATTENTIVE',
  INTERNAL_ANALYTICS: 'INTERNAL_ANALYTICS',
  PARTNER_PRODUCT_LIST: 'PARTNER_PRODUCT_LIST',
  RECOMMENDATION: 'RECOMMENDATION',
  FORM_MODAL: 'FORM_MODAL',
  MIXPANEL_ANALYTICS: 'MIXPANEL_ANALYTICS',
  SERVER_PIXEL: 'SERVER_PIXEL',
  COOKIE_STORAGE: 'COOKIE_STORAGE',
  LOCAL_STORAGE: 'LOCAL_STORAGE',
  SESSION_STORAGE: 'SESSION_STORAGE',
  ORDERS_PAGE: 'ORDERS_PAGE',
  ADDRESS: 'ADDRESS',
  URL_PARAMS: 'URL_PARAMS',
  PAGE_CONTEXT_SESSION_STORAGE: 'PAGE_CONTEXT_SESSION_STORAGE',
  IMAGE_RENDER: 'IMAGE_RENDER',
  HOME_PAGE: 'HOME_PAGE',
  CART_SECTION: 'CART_SECTION',
  BROWSER_INFO: 'BROWSER_INFO',
  PRODUCT_CARD: 'PRODUCT_CARD',
  POST_ORDER_WEB: 'POST_ORDER_WEB',
  QUINCE_APP: 'QUINCE_APP',
  LOCALE: 'LOCALE',
  COLLECTION: 'COLLECTION',
  MINI_PDP: 'MINI_PDP',
  UNIVERSAL_AUTH: 'UNIVERSAL_AUTH',
  STYLITICS_RECOMMENDATION: 'STYLITICS_RECOMMENDATION',
  SIGN_UP: 'SIGN_UP',
  FIND_MY_ORDER: 'FIND_MY_ORDER',
  PL_WIDGET: 'PL_WIDGET',
  PL: 'PL',
  B2B_CUSTOMIZATION_PAGE: 'B2B_CUSTOMIZATION_PAGE',
} as const

export type ModuleType = (typeof MODULES)[keyof typeof MODULES]

export const FEATURES = {
  UNKNOWN: 'UNKNOWN',
  IMAGE_TRANSFORMATION: 'IMAGE_TRANSFORMATION',
  VIDEO_TRANSFORMATION: 'VIDEO_TRANSFORMATION',
  SUBMIT_REVIEW: 'SUBMIT_REVIEW',
  UNHANDLED_RICHTEXT_EMBEDDED_ENTRY: 'UNHANDLED_RICHTEXT_EMBEDDED_ENTRY',
  FILTER_CHANGE: 'FILTER_CHANGE',
  PAGINATION: 'PAGINATION',
  TRENDING_SEARCH_SUGGESTIONS: 'TRENDING_SEARCH_SUGGESTIONS',
  SITE_DATA: 'SITE_DATA',
  ADD_TO_CART: 'ADD_TO_CART',
  BUY_NOW_CART: 'BUY_NOW_CART',
  REMOVE_ITEM: 'REMOVE_ITEM',
  UPDATE_LINE_ITEM: 'UPDATE_LINE_ITEM',
  INIT_CHECKOUT: 'INIT_CHECKOUT',
  EXPRESS_CHECKOUT: 'EXPRESS_CHECKOUT',
  FETCH_STORE_CREDIT: 'FETCH_STORE_CREDIT',
  ADD_MULTI_ITEM_TO_CART: 'ADD_MULTI_ITEM_TO_CART',
  ADD_BULK_ORDER_CUSTOMIZATION_TO_CART: 'ADD_BULK_ORDER_CUSTOMIZATION_TO_CART',
  FETCH_FULL_PRODUCT: 'FETCH_FULL_PRODUCT',
  RETURN_PAGE_LOAD: 'RETURN_PAGE_LOAD',
  RETURN_STEP_CHANGE: 'RETURN_STEP_CHANGE',
  GET_PRODUCT_FEED: 'GET_PRODUCT_FEED',
  GET_PRODUCT: 'GET_PRODUCT',
  SEARCH: 'SEARCH',
  SEARCH_RESULT: 'SEARCH_RESULT',
  FETCH_WISHLIST: 'FETCH_WISHLIST',
  FETCH_WISHLIST_PRODUCTS: 'FETCH_WISHLIST_PRODUCTS',
  FETCH_RECOMMENDED_TABS: 'FETCH_RECOMMENDED_TABS',
  ERROR_BOUNDARY: 'ERROR_BOUNDARY',
  FETCH_TRACKING_DATA: 'FETCH_TRACKING_DATA',
  UPDATE_WISHLIST: 'UPDATE_WISHLIST',
  TOGGLE_WISHLIST: 'TOGGLE_WISHLIST',
  IS_OLD_USER: 'IS_OLD_USER',
  GET_UUID: 'GET_UUID',
  SUBSCRIBE_EMAIL: 'SUBSCRIBE_EMAIL',
  FETCH_REVIEW: 'FETCH_REVIEW',
  PRODUCT_PAGE_RUNTIME_REFRESH: 'PRODUCT_PAGE_RUNTIME_REFRESH',
  GET_CHECKOUT_FROM_LOCAL_STORAGE: 'GET_CHECKOUT_FROM_LOCAL_STORAGE',
  DISCOUNT_CODE: 'DISCOUNT_CODE',
  TRACK_EVENT: 'TRACK_EVENT',
  TRACK_GA: 'TRACK_GA',
  TRACK_INTERNAL_ANALYTICS: 'TRACK_INTERNAL_ANALYTICS',
  LOAD_SDK: 'LOAD_SDK',
  GET_EMAIL_FROM_DATA_LAYER: 'GET_EMAIL_FROM_DATA_LAYER',
  EXECUTE_SAFELY: 'EXECUTE_SAFELY',
  GET_COOKIE: 'GET_COOKIE',
  IMAGE_UPLOAD: 'IMAGE_UPLOAD',
  GET_ORDERS: 'GET_ORDERS',
  GET_ORDER_DETAILS: 'GET_ORDER_DETAILS',
  FBT: 'FBT',
  YMAL: 'YMAL',
  MTE: 'MTE',
  CTL: 'CTL',
  SORT_PRODUCTS_RUNTIME: 'SORT_PRODUCTS_RUNTIME',
  SEND_FORM_DATA: 'SEND_FORM_DATA',
  UPDATE_COLOR_OPTIONS: 'UPDATE_COLOR_OPTIONS',
  MIXPANEL_ANALYTICS_API: 'MIXPANEL_ANALYTICS_API',
  SERVER_PIXEL_API: 'SERVER_PIXEL_API',
  SET_COOKIE: 'SET_COOKIE',
  SET_IN_LOCAL_STORAGE_WITH_EXPIRY: 'SET_IN_LOCAL_STORAGE_WITH_EXPIRY',
  GET_FROM_LOCAL_STORAGE_WITH_EXPIRY: 'GET_FROM_LOCAL_STORAGE_WITH_EXPIRY',
  SET_IN_SESSION_STORAGE_WITH_EXPIRY: 'SET_IN_SESSION_STORAGE_WITH_EXPIRY',
  GET_FROM_SESSION_STORAGE_WITH_EXPIRY: 'GET_FROM_SESSION_STORAGE_WITH_EXPIRY',
  CREATE_ADDRESS: 'CREATE_ADDRESS',
  EDIT_ADDRESS: 'EDIT_ADDRESS',
  DELETE_ADDRESS: 'DELETE_ADDRESS',
  FETCH_ADDRESS: 'FETCH_ADDRESS',
  VALIDATE_ADDRESS: 'VALIDATE_ADDRESS',
  PREVIOUS_PAGE_CONTEXT: 'PREVIOUS_PAGE_CONTEXT',
  PREVIOUS_PAGE_QPID: 'PREVIOUS_PAGE_QPID',
  SET_PAGE_CONTEXT: 'SET_PAGE_CONTEXT',
  GET_PAGE_CONTEXT: 'GET_PAGE_CONTEXT',
  REVIEW_IMAGE_POPUP: 'REVIEW_IMAGE_POPUP',
  REVIEW_IMAGE_POPUP_SLIDE_LEFT: 'REVIEW_IMAGE_POPUP_SLIDE_LEFT',
  REVIEW_IMAGE_POPUP_SLIDE_RIGHT: 'REVIEW_IMAGE_POPUP_SLIDE_RIGHT',
  REVIEW_IMAGE_PARENT_SLIDE_CHANGE: 'REVIEW_IMAGE_PARENT_SLIDE_CHANGE',
  IMAGE: 'IMAGE',
  RECOMMENDATION_MAPPER: 'RECOMMENDATION_MAPPER',
  IMAGE_WITH_SRC: 'IMAGE_WITH_SRC',
  IMAGE_FILL_WITH_BLACK_BACKGROUND: 'IMAGE_FILL_WITH_BLACK_BACKGROUND',
  EXPLORE_EVERYTHING_SECTION: 'EXPLORE_EVERYTHING_SECTION',
  URL_PARAMS: 'URL_PARAMS',
  PAIRED_PRODUCTS: 'PAIRED_PRODUCTS',
  SGTM_API: 'SGTM_API',
  IP_ADDRESS: 'IP_ADDRESS',
  USER_AGENT: 'USER_AGENT',
  CLICK_SWATCH_LINK: 'CLICK_SWATCH_LINK',
  BASED_ON_YOUR_TASTE: 'BASED_ON_YOUR_TASTE',
  FINDING_METHODS: 'FINDING_METHODS',
  CART_EXPRESS_CHECKOUT: 'CART_EXPRESS_CHECKOUT',
  RETURNS_REVAMP: 'RETURNS_REVAMP',
  E_GIFTING: 'E_GIFTING',
  ORDERS: 'ORDERS',
  ORDER_DETAILS: 'ORDER_DETAILS',
  MANAGE_RETURNS: 'MANAGE_RETURNS',
  EMIT_REACT_NATIVE_EVENT: 'EMIT_REACT_NATIVE_EVENT',
  SAVE_FOR_LATER: 'SAVE_FOR_LATER',
  REMOVE_OUT_OF_STOCK_ITEMS: 'REMOVE_OUT_OF_STOCK_ITEMS',
  REFRESH_FULFILLMENT_DETAILS: 'REFRESH_FULFILLMENT_DETAILS',
  SWITCH_LOCALE_CONFIRMATION: 'SWITCH_LOCALE_CONFIRMATION',
  COLLECTION: 'COLLECTION',
  UNIVERSAL_AUTH: 'UNIVERSAL_AUTH',
  LOAD_STYLITICS_COMPOSER: 'LOAD_STYLITICS_COMPOSER',
  SIGN_UP: 'SIGN_UP',
  FIND_MY_ORDER: 'FIND_MY_ORDER',
  REFRESH_STYLITICS: 'REFRESH_STYLITICS',
  STYLITICS_JUMPLINK: 'STYLITICS_JUMPLINK',
  B2B_CUSTOMIZATION_PAGE: 'B2B_CUSTOMIZATION_PAGE',
  SUBSCRIPTIONS: 'SUBSCRIPTIONS',
  WIDGET_ERROR: 'WIDGET_ERROR',
  WIDGET_UNKNOWN: 'WIDGET_UNKNOWN',
  LAYOUT_PAGINATION: 'LAYOUT_PAGINATION',
  WIDGET_PAGINATION: 'WIDGET_PAGINATION',
  API_FETCH: 'API_FETCH',
  CLP_IMAGE_CONFIG: 'CLP_IMAGE_CONFIG',
  PRODUCT_PURCHASE_INFO: 'PRODUCT_PURCHASE_INFO',
  CLP_FILTERS_CONFIG: 'CLP_FILTERS_CONFIG',
  FINGERPRINTING: 'FINGERPRINTING',
  EDD: 'EDD',
} as const

export type FeatureType = (typeof FEATURES)[keyof typeof FEATURES]
